import { computed, makeObservable } from 'mobx';
import NumeroProcessoUtil from '../../util/NumeroProcessoUtil';
import { Filtro } from './Filtro';

export default class FiltroNumeroProcesso extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;
    ocultaValoresChipFiltroAtivo = true;
    ocultaFiltro = true;

    get label() {
        return 'Lista de números de processos';
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            carregandoDadosComplementares: computed
        });
    }

    getValorOpcao(registro) {
        return [
            registro.processo.numeroCompleto,
            NumeroProcessoUtil.removerClasseProcessual(registro.processo.numeroCompleto),
            NumeroProcessoUtil.formatarNumeroProcesso(registro.processo.numeroCompleto, false, true)
        ];
    }

    get carregandoDadosComplementares() {
        return this.store.carregandoUltimosAndamentos;
    }

    renderCarregando() {
        return this.renderCircularProgress('Filtrando pelos números de processos...');
    }
}
